import { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import QuotePage from './pages/QuotePage';

function App() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [quoteSubmitted, setQuoteSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Sync activeTab with the URL
  const getActiveTabFromPath = () => {
    const path = location.pathname.substring(1); // Remove leading '/'
    return path || 'home'; // Default to 'home' if path is empty
  };

  const activeTab = getActiveTabFromPath();

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation 
        activeTab={activeTab}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route 
            path="/contact" 
            element={
              <ContactPage 
                submitted={submitted}
                setSubmitted={setSubmitted}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            } 
          />
          <Route 
            path="/quote" 
            element={
              <QuotePage 
                quoteSubmitted={quoteSubmitted}
                setQuoteSubmitted={setQuoteSubmitted}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            } 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;